import {
  IonHeader, IonPage, IonToolbar, IonTitle, IonContent, IonFab, IonFabButton, IonIcon, IonItem, IonRow, IonCardContent, IonCard, IonCol, IonLabel, IonRadioGroup, IonRadio, IonCardHeader, IonSelect, IonButton, IonSelectOption, IonBadge, IonRange, IonInput, IonThumbnail, IonImg
} from '@ionic/react';
import React from 'react';
import * as API from "../utils/api";
import * as apiConstants from "../constants/api-endpoint";
import { CustomerDetail } from '../interface/customerDetails.i';
import { camera, chevronBackSharp } from 'ionicons/icons';
import Swal from 'sweetalert2';
import LogoutPage from './Logout';
import styled from "styled-components";
import { CAMERA } from '../utils/shared';
import { Header, InspectionQuestions, PumpOutQuestionResponse, Question } from '../interface/question.i';
import AudioRecoder from '../components/Recorder/AudioRecoder';
//import Radio from './Radiobutton';


class PumpOutPage extends React.Component<any, any> {

  private selectedData: CustomerDetail;
  private pageNumber: number = 1;
  private pageNum: number = 2;
  private page: number = 5;
  private previousPageNumber: number = 0;
  private currentPageNumber: number = 0;
  private nextPageNumber: number = 0;
  private disableNextPage: boolean = false;

  constructor(props: any) {
    super(props);
    console.log(" props data ==> ", props);
    this.selectedData = props.location.state.userData;
    this.state = { data: [] as Question[], selectedData: this.selectedData, headerTO: {} as Header, pumpoutDetailsTO: {} as InspectionQuestions, pumpOutQuestion: {} as PumpOutQuestionResponse, photo : [], disableSubmitButton : false}
  }

  componentDidMount() {
    this.invokeQuestionService();
  }

  assigndisableFlagfn(obj:any, length: number) {
    const len = Array(length);
    for (let index = 25; index <= length; index++) {
      obj[index].disableFlag = true; 
      obj[index].mandatory = false;   
    }
    return obj;
  }

  goBack = () => {
    //To goto previous page
    const lastPageNumber = this.state.pumpoutDetailsTO.lastPageNumber;
    const sequenceNumber = this.state.pumpoutDetailsTO.sequenceNumber;
    const previousModuleLastPageNumber = this.state.pumpoutDetailsTO.previousModuleLastPageNumber;
    if (this.state.headerTO.title == 'PROPERTY INFO' && this.currentPageNumber != 2 && this.state.pumpoutDetailsTO.moduleNumber != null && this.state.pumpoutDetailsTO.moduleNumber != 'scndSystemModule1') {
      this.props.history.goBack();
    } else if (this.state.pumpoutDetailsTO.moduleNumber != null && this.state.pumpoutDetailsTO.moduleNumber == 'scndSystemModule1' && this.currentPageNumber == 1) {
      this.pageNavigation(this.selectedData.id, previousModuleLastPageNumber)
    } else if (this.previousPageNumber == 0) {
      this.pageNavigation(this.selectedData.id, this.pageNumber);
    } else {
      this.pageNavigation(this.selectedData.id, this.previousPageNumber);
    }
  }

  gotoNextPage = () => {
    //To goto nextpage
    const pumpOutQuestionTOs = this.state.data as Question[];
    this.setState((prevState : any) => ({ key: prevState.key + 1 }));
    this.updatePumpOut();
    if(this.disableNextPage == false) {
      this.pageNavigation(this.selectedData.id, this.nextPageNumber, 'nextPage');
    }
  }

  invokeQuestionService = () => {
    if (this.selectedData && this.selectedData.id) {
      this.questionService(this.selectedData.id, this.pageNumber);
    }
  }

  questionService = (id: number, pNo: number) => {
    // present("Please wait...", 1000);
    this.navigationApiCall(apiConstants.pumpoutquestionsfirstpage + id);
  }

  pageNavigation = (id: number, pNo: number, nav?: string) => {
    // present("Please wait...", 1000);
    const pumpoutType = this.props.location.state.userData.typeOfCustomer;
    const currentModule = this.state.pumpoutDetailsTO.currentModule;
    const moduleNumber = this.state.pumpoutDetailsTO.moduleNumber;
    const typeFromBackEnd = this.state.pumpoutDetailsTO.typeFromBackEnd;
    const typeFromUI = this.state.pumpoutDetailsTO.typeFromUI;
    const previousModule = this.state.pumpoutDetailsTO.previousModule;
    const previousmoduleNumber = this.state.pumpoutDetailsTO.previousModuleNumber;
    const previousmoduleLastPageNumber = this.state.pumpoutDetailsTO.previousModuleLastPageNumber;
    const currentPageNumber = this.state.pumpoutDetailsTO.currentPageNumber;
    const lastPageNumber = this.state.pumpoutDetailsTO.lastPageNumber;
    const previousPageNumber = this.state.pumpoutDetailsTO.previousPageNumber;
    let sequenceNumber = this.state.headerTO.sequenceNumber;
    const direction = "backward";
    let pageno = pNo + 1;
    let url = '';
    if ((currentModule != previousModule && previousPageNumber == 0) || (currentModule == previousModule && previousPageNumber == 0 && (previousmoduleNumber != moduleNumber))) {
      url = apiConstants.pumpoutquestions + id + '&page=' + previousmoduleLastPageNumber + '&currentModule=' + previousModule + '&moduleNumber=' + previousmoduleNumber + '&direction=' + direction + '&user=' + localStorage.username;
    }

    if (previousPageNumber != 0 && sequenceNumber != 0) {
      url = apiConstants.pumpoutquestions + id + '&page=' + pNo + '&currentModule=' + currentModule + '&moduleNumber=' + moduleNumber + '&typeFromBackEnd=' + typeFromBackEnd+ '&typeFromUI=' + typeFromUI + '&direction=' + direction + '&pumpoutType=' + pumpoutType + '&sequenceNumber=' + sequenceNumber + '&user=' + localStorage.username;
    }

    if(currentModule != null && (currentModule == 'Cancel' || currentModule == 'Complete Pumpout')) {
      url = apiConstants.pumpoutquestions + id + '&page=' + previousmoduleLastPageNumber + '&currentModule=' + previousModule + '&moduleNumber=' + previousmoduleNumber + '&direction=' + direction + '&pumpoutType=' + pumpoutType + '&sequenceNumber=' + sequenceNumber + '&user=' + localStorage.username;
    }

    if (nav === "nextPage") {
      url = apiConstants.pumpoutquestions + id + '&page=' + pNo + '&currentModule=' + currentModule + '&moduleNumber=' + moduleNumber + '&typeFromBackEnd=' + typeFromBackEnd+ '&typeFromUI=' + typeFromUI + '&direction=forward' + '&pumpoutType=' + pumpoutType + '&sequenceNumber=' + sequenceNumber + '&user=' + localStorage.username;
    }

    this.navigationApiCall(url)
  }

  navigationApiCall = (url: string) => {
    const pumpoutType = this.props.location.state.userData.typeOfCustomer;
    API.authGetRequest(url, '')
      .then((res) => {
        if (res && res.data) {
          const responseData = res.data;
          //responseData.headerTO = this.state.pumpOutQuestion.headerTO;
          this.previousPageNumber = responseData.previousPageNumber;
          this.nextPageNumber = responseData.nextPageNumber;
          this.currentPageNumber = responseData.currentPageNumber;
          const data = responseData.pumpOutQuestionTOs as Question[];

          if (data && data.length) {
            data.map((o, i) => {
              if (o.answerType === 'range' || o.answerType == 'range inches' || o.answerType == 'range gallons'
                || o.answerType == 'range feet' || o.answerType == 'range hide' || o.answerType == 'range hose') {
                const str = o.answerValue as string;
                const label = o.label as string;
                o.answer = o.answer ? o.answer : '0';
                o.answer = (!isNaN(Number(o.answer)) ? o.answer : '0');
                o.answerValue = str.split('-').map(Number);
                if (label) {
                  o.label = label.split('-');
                }
              }
            })
          }
          if(this.currentPageNumber == 1 && responseData.pumpOutQuestionTOs[0].compartmentType == '1 Compartment') {
            if(pumpoutType == 'New Pumpout Customer' || pumpoutType == 'Pumpout Customer') {
            if(responseData.pumpOutQuestionTOs[23].answer != null && responseData.pumpOutQuestionTOs[23].answer == responseData.pumpOutQuestionTOs[24].answer) {
              const pumpOutQuestionTOs = this.assigndisableFlagfn(responseData.pumpOutQuestionTOs, 32);
              responseData.pumpOutQuestionTOs = pumpOutQuestionTOs;
            }
          }
          }
          if(this.currentPageNumber == 1 && responseData.pumpOutQuestionTOs[0].compartmentType == '1 Compartment' && pumpoutType == 'Inspection') {
            if(responseData.pumpOutQuestionTOs[6].answer != null && responseData.pumpOutQuestionTOs[6].answer == responseData.pumpOutQuestionTOs[7].answer) {
              responseData.pumpOutQuestionTOs[8].disableFlag = true;
              responseData.pumpOutQuestionTOs[8].mandatory = false;
            }
          }
          if(this.currentPageNumber == 1 && responseData.pumpOutQuestionTOs[0].compartmentType == '1 Compartment' && pumpoutType == 'Service Customer') {
            if(responseData.pumpOutQuestionTOs[23].answer != null && responseData.pumpOutQuestionTOs[23].answer == responseData.pumpOutQuestionTOs[24].answer) {
              responseData.pumpOutQuestionTOs[24].disableFlag = true;
              responseData.pumpOutQuestionTOs[24].mandatory = false;
            }
          }
          if(this.currentPageNumber == 2 && responseData.pumpOutQuestionTOs[0].compartmentType == '2 Compartment') {
            if(pumpoutType == 'New Pumpout Customer' || pumpoutType == 'Pumpout Customer') {
            if(responseData.pumpOutQuestionTOs[23].answer != null && responseData.pumpOutQuestionTOs[23].answer == responseData.pumpOutQuestionTOs[24].answer) {
              const pumpOutQuestionTOs = this.assigndisableFlagfn(responseData.pumpOutQuestionTOs, 32);
              responseData.pumpOutQuestionTOs = pumpOutQuestionTOs;
            }
          }
          }
          if(this.currentPageNumber == 2 && responseData.pumpOutQuestionTOs[0].compartmentType == '2 Compartment' && pumpoutType == 'Inspection') {
            if(responseData.pumpOutQuestionTOs[6].answer != null && responseData.pumpOutQuestionTOs[6].answer == responseData.pumpOutQuestionTOs[7].answer) {
              responseData.pumpOutQuestionTOs[8].disableFlag = true;
              responseData.pumpOutQuestionTOs[8].mandatory = false;
            }
          }
          if(this.currentPageNumber == 2 && responseData.pumpOutQuestionTOs[0].compartmentType == '2 Compartment' && pumpoutType == 'Service Customer') {
            if(responseData.pumpOutQuestionTOs[23].answer != null && responseData.pumpOutQuestionTOs[23].answer == responseData.pumpOutQuestionTOs[24].answer) {
              responseData.pumpOutQuestionTOs[24].disableFlag = true;
              responseData.pumpOutQuestionTOs[24].mandatory = false;
            }
          }
          if(responseData.headerTO.title == 'DRAINAGE FIELD' && responseData.pumpOutQuestionTOs[0].answer == 'Unknown') {
            responseData.pumpOutQuestionTOs[1].disableFlag = true; 
            responseData.pumpOutQuestionTOs[1].mandatory = false;  
            responseData.pumpOutQuestionTOs[2].disableFlag = true;
            responseData.pumpOutQuestionTOs[2].mandatory = false;
            responseData.pumpOutQuestionTOs[3].disableFlag = true;
            responseData.pumpOutQuestionTOs[3].mandatory = false;     
          }
          this.setState({
            pumpoutDetailsTO: responseData.pumpoutDetailsTO,
            headerTO: responseData.headerTO,
            data: responseData.pumpOutQuestionTOs,
            pumpOutQuestion: responseData
          }) 
          if (data && data.length) {
            data.map((o, i) => {
              this.dropdownOnchange(o, i)
              this.radioOnchange(o, i)
            })
        }      
        }
      })
      .catch((error) => {
        console.log("err===", error);
      });
  }

  //child component
  handleCallback = async (childData: any, index : number) => {
    // Update the data in the component's state
    this.setState({ audioData: childData })
    console.log("childData", childData)
    let name = childData.url;
    const myArray = name.split("blob:http://localhost:8100/");
    console.log(myArray[1]);
    let fileName = myArray[1] + ".wav";
    const file: any = childData;
    const audioFile = new File([file.blob], fileName, { type: 'audio/wav' });
    const formdata = new FormData();
    formdata.append('file1', audioFile);
    this.uploadAudio(await formdata, this.selectedData.id);

  }

  //Upload Audio
  uploadAudio(formdata: FormData, id: number) {
    const type = "pumpout";
    const compartmentType = this.state.data[1].compartmentType;
    const moduleNumber = this.state.pumpoutDetailsTO.moduleNumber;
    const uploadAudio = API.authPostRequest(apiConstants.photoUploadUrl + id + '&type=' + type + '&moduleNumber=' + moduleNumber + '&compartment=' + compartmentType, formdata);
    uploadAudio
      .then(async () => {
        console.log('Audio Uploaded Successfully');
      })
      .catch((error) => {
        console.log(error);
      });
  };

  OnChangeDropdown = (event: any, id: number, index: number, pNo: number) => {
    //To display questions based on dropdown value choosen
    const pumpoutType = this.props.location.state.userData.typeOfCustomer;
    const sequenceNumber = this.state.pumpOutQuestion.headerTO.sequenceNumber;
    const direction = "forward";
    let val = event.detail.value;
    console.log("dropdown value", val);
    const number = this.state.pumpoutDetailsTO.moduleNumber;
    // const moduleNumber = "module" + parseInt(number.split('module')[1] + 1);
    let result = [];
    if(number.includes('module')) {
      result = number.split('module');
    }
    if(number.includes('scndSystemModule')) {
      result = number.split('scndSystemModule');
    }
    let res = parseInt(result[1]) + 1;
    let moduleNumber = "";
    if(number.includes('module')) {
      moduleNumber = "module" + res;
    }
    if(number.includes('scndSystemModule')) {
      moduleNumber = "scndSystemModule" + res;
    }
    const typeFromBackEnd = this.state.pumpoutDetailsTO.typeFromBackEnd;
    const lastPage = this.state.pumpoutDetailsTO.lastPage;
    console.log("=====", lastPage);

    let url = "";
      if (val == 'Cancel') {
        url = apiConstants.pumpoutquestions + id + '&page=1' + '&currentModule=' + val + '&moduleNumber=' + number + '&sequenceNumber=' + sequenceNumber + '&user=' + localStorage.username;
      } else if (val == 'Second system') {
        url = apiConstants.pumpoutquestionssecondsystemfirstpage + id + '&user=' + localStorage.username;
      } else {
        url = apiConstants.pumpoutquestions + id + '&page=1' + '&currentModule=' + val + '&moduleNumber=' + moduleNumber + '&typeFromBackEnd=' + typeFromBackEnd+ '&typeFromUI=' + val + '&direction=' + direction + '&pumpoutType=' + pumpoutType + '&sequenceNumber=' + sequenceNumber + '&user=' + localStorage.username;
      }
    this.navigationApiCall(url);
    this.ServiceQuestionUpdate(event.detail.value, index);
    this.updatePumpOut();  
  }

  getPumpOutReport = (id:number) => {
    //to display popup alertbox on clicking submit button
    Swal.fire({
      title: 'Are you sure you want to submit?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'Submit',
      denyButtonText: `Don't Submit`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({disableSubmitButton : true})
        const name = localStorage.username;
        const submit = apiConstants.submitPumpoutReport + id + '/' + name;
        API.authGetRequest(submit, '')
        .then((res) => {
          const responseData = res.data;
          if(responseData.message == 'Pumpout Completed'){
            Swal.fire('Success!', responseData.message ,'success')
            this.props.history.push('/upcoming-schedule?selection=pumpoutschedule')
          } else if(responseData.message == 'Pumpout Cancelled'){
            Swal.fire('Success!', responseData.message ,'success')
            this.props.history.push('/upcoming-schedule?selection=pumpoutschedule')
          } 
        })
      } else {
        Swal.fire('Changes are not saved', '', 'info')
      }
    })
  .catch((error) => {
    console.log("err===", error);
  })  
  this.updatePumpOut();
  }

  range = () => {
    const inspectionQuestionTOs = this.state.data as Question[];
    inspectionQuestionTOs.map((el: Question) => {
      if (el.answerType === 'range' || el.answerType == 'range hide' || el.answerType == 'range inches' || el.answerType == 'range gallons' || el.answerType == 'range feet') {
        el.answerValue = (el.answerValue as string).split('-');
        el.label = (el.label as string).split('-');
        el.answer = el.answer.toString();
      }
    });
  }

  updatePumpOut = () => {
    //Update pumpout values to the database
    this.disableNextPage = false;
    try{
    const pumpOutQuestionTOs = this.state.data as Question[];
    pumpOutQuestionTOs.map((el: Question) => {
      if(el?.mandatory && (el.answer == null || el.answer == 'NaN')) {
        this.disableNextPage = true;
        this.range();
        throw "mandatory";
      }
      if (el.answerType === 'Choose equipment' || el.answerType === 'drop down' || el.answerType == 'drop down hide' 
      || (el.answerType === 'multiselect' && el.answer === 'null') || (el.answerType === 'drop down multiple' && el.answer === 'null') ||
      (el.answerType === 'checkbox' && el.answer === 'null')) {
        el.answerValue = el.answerValue.toString();
      }
      if (el.answerType === 'range' || el.answerType == 'range hide' || el.answerType == 'range hose' || el.answerType == 'range gallons' || el.answerType == 'range inches') {
        el.answerValue = (el.answerValue as string[]).join('-');
        el.label = (el.label as string[]).join('-');
        el.answer = el.answer.toString();
      }
      if (el.answerType == 'calculateValues' && el.answer != null) {
        el.answer = el.answer.toString();
      }
    });
  } catch(exception) {
    console.log("error");
    return;
  }

    let update = this.state.pumpOutQuestion;
    let num = this.selectedData.id;
    let name = localStorage.username;
    const updatePumpOutData = API.authPostRequest(apiConstants.updatePumpOut + num + '/' + name, update);
    console.log("url", updatePumpOutData);
    updatePumpOutData
      .then(async (res) => {
        console.log('Pumpout Data Updated Successfully', res);
      })
      .catch((error) => {
        console.log("err===", error);
      });
    }

  ServiceQuestionUpdate(event: any, index: number) {
    //To save selected radio and dropdown event values
    const updatedData = { ...this.state.pumpOutQuestion };
    if (updatedData && updatedData.pumpOutQuestionTOs.length > index && updatedData.pumpOutQuestionTOs[index]) {
      updatedData.pumpOutQuestionTOs[index].answer = event;
      this.setState({
        pumpOutQuestion: updatedData
      });
      console.log(event);
    }
  }

  rangeQuestionUpdate = (answer: any, index: number) => {
    const updatedData = { ...this.state.pumpOutQuestion };
    if (updatedData && updatedData.pumpOutQuestionTOs.length > index && updatedData.pumpOutQuestionTOs[index]) {
      updatedData.pumpOutQuestionTOs[index].answer = (!isNaN(Number(answer)) ? answer : '0');
      this.setState({
        pumpOutQuestion: updatedData
      });
      console.log(answer);
    }
  }

rangeUpdate(event: any, index: number) {
    //To update range values
    const updatedData = { ...this.state };
    if (updatedData && updatedData.data && updatedData.data.length &&
      updatedData.data.length > index && updatedData.data[index].answer) {
      updatedData.data[index].answer = (!isNaN(Number(event)) ? event : '0');

      if ((this.currentPageNumber == 1 && updatedData.data[index].compartmentType == '1 Compartment' || 
         this.currentPageNumber == 2 && updatedData.data[index].compartmentType == '2 Compartment') && (this.state.headerTO.pumpoutType == 'New Pumpout Customer' || this.state.headerTO.pumpoutType == 'Pumpout Customer')) {

        if(updatedData.data[index].questionReference == 'liquid_removed_as_per_pumper') {
          if (updatedData.data[index].answer == updatedData.data[index - 1].answer) {
            updatedData.data[index + 1].disableFlag = true;
            updatedData.data[index + 1].mandatory = false;
            updatedData.data[index + 2].disableFlag = true;
            updatedData.data[index + 2].mandatory = false;
            updatedData.data[index + 3].disableFlag = true;
            updatedData.data[index + 3].mandatory = false;
            updatedData.data[index + 4].disableFlag = true;
            updatedData.data[index + 4].mandatory = false;
            updatedData.data[index + 5].disableFlag = true;
            updatedData.data[index + 5].mandatory = false;
            updatedData.data[index + 6].disableFlag = true;
            updatedData.data[index + 6].mandatory = false;
            updatedData.data[index + 7].disableFlag = true;
            updatedData.data[index + 7].mandatory = false;
            updatedData.data[index + 8].disableFlag = true;
            updatedData.data[index + 8].mandatory = false;
          } else {
            updatedData.data[index + 1].disableFlag = false;
            updatedData.data[index + 1].mandatory = true;
            updatedData.data[index + 2].disableFlag = false;
            updatedData.data[index + 2].mandatory = true;
            updatedData.data[index + 3].disableFlag = false;
            updatedData.data[index + 3].mandatory = true;
            updatedData.data[index + 4].disableFlag = false;
            updatedData.data[index + 4].mandatory = true;
            updatedData.data[index + 5].disableFlag = false;
            updatedData.data[index + 5].mandatory = true;
            updatedData.data[index + 6].disableFlag = false;
            updatedData.data[index + 6].mandatory = true;
            updatedData.data[index + 7].disableFlag = false;
            updatedData.data[index + 7].mandatory = true;
            updatedData.data[index + 8].disableFlag = false;
            updatedData.data[index + 8].mandatory = true;
          }
        }
    } else {
      if(updatedData.data[index].questionReference == 'liquid_removed_as_per_pumper' && (this.state.headerTO.pumpoutType == 'Service Customer' || this.state.headerTO.pumpoutType == 'Inspection')) {
        if (updatedData.data[index].answer == updatedData.data[index - 1].answer) {
          updatedData.data[index + 1].disableFlag = true;
          updatedData.data[index + 1].mandatory = false;
        } else {
          updatedData.data[index + 1].disableFlag = false;
          updatedData.data[index + 1].mandatory = true;
        }
      }
    }

      this.setState({
        data: updatedData.data
      })
      console.log(event);
    }
    this.rangeQuestionUpdate(event, index);
  }

  textOnchange(event: any, index: number) {
    this.ServiceQuestionUpdate(event, index);
  }

  handleKeyPress = (event : any) => {
    if (event.key === 'Enter') {
      // Prevent the default behavior (form submission) on Enter press
      event.preventDefault();

      // Do something when the Enter key is pressed
      return true;
    }
  };

  textOnChange = (event: any, index: number) => {
    const updatedData = { ...this.state.pumpOutQuestion };
    if (updatedData && updatedData.pumpOutQuestionTOs.length > index && updatedData.pumpOutQuestionTOs[index]) {
      updatedData.pumpOutQuestionTOs[index].answer = event;

      //1 Compartment Round Logics
      if(this.currentPageNumber == 5 && updatedData.pumpOutQuestionTOs[index].compartmentType == '1 Compartment') {
        if(updatedData.pumpOutQuestionTOs[index].mobileView == 'DEPTH OF TANK(IN INCHES)' && updatedData.pumpOutQuestionTOs[index - 3].answer == 'Round') {
          updatedData.pumpOutQuestionTOs[index].answer = event;
          let diameter = updatedData.pumpOutQuestionTOs[index - 1].answer - 6;
          let radius = diameter/2;
          let height = updatedData.pumpOutQuestionTOs[index].answer;
          let labelAnswer = (3.14159 * radius * radius * height) / 231;
          let roundOff = Math.round(labelAnswer);
          if (roundOff >= 900 && roundOff <= 1160) {
            roundOff = 1000;
          } else if (roundOff > 1160 && roundOff <= 1270) {
            roundOff = 1250;
          } else if (roundOff > 1270 && roundOff <= 1400) {
            roundOff = 1300;
          } else if (roundOff > 1400 && roundOff <= 1625) {
            roundOff = 1500;
          } else if (roundOff > 1625 && roundOff <= 1875) {
            roundOff = 1750;
          } else if (roundOff > 1875) {
            roundOff = 2000;
          }
          updatedData.pumpOutQuestionTOs[index + 3].answer = roundOff;
        }

         //1 Compartment rectangle logics (Tank Volume)
         if(updatedData.pumpOutQuestionTOs[index].mobileView == 'WIDTH OF TANK(IN INCHES)' && updatedData.pumpOutQuestionTOs[index - 5].answer == 'Rectangle') {
          updatedData.pumpOutQuestionTOs[index].answer = event;
          let length = updatedData.pumpOutQuestionTOs[index - 1].answer -6;
          let breadth = updatedData.pumpOutQuestionTOs[index].answer - 6;
          let height = updatedData.pumpOutQuestionTOs[index - 3].answer;
          let labelAnswer = (length * breadth * height) / 231;
          console.log("labelAnswer=",labelAnswer);
          let roundOff = Math.round(labelAnswer);
          if (roundOff >= 900 && roundOff <= 1160) {
            roundOff = 1000;
          } else if (roundOff > 1160 && roundOff <= 1270) {
            roundOff = 1250;
          } else if (roundOff > 1270 && roundOff <= 1400) {
            roundOff = 1300;
          } else if (roundOff > 1400 && roundOff <= 1625) {
            roundOff = 1500;
          } else if (roundOff > 1625 && roundOff <= 1875) {
            roundOff = 1750;
          } else if (roundOff > 1875) {
            roundOff = 2000;
          }
          updatedData.pumpOutQuestionTOs[index + 1].answer = roundOff;
        }
      }
    }
    this.ServiceQuestionUpdate(event, index);
  }

  radioOnchange = (event: any, index: number) => {
    //Logics to hide & disable questions based on radiobutton question and answer choosen
    // if (!event?.detail?.value) return;
    const updateEvent = this.state.data as Question[];
    let selectedQuestion = event?.target?.innerText;
    let selectedAnswer = event?.detail?.value;
    if(event?.mobileView) {
      selectedQuestion = event.mobileView;
      selectedAnswer = event.answer;
    }
    if (selectedQuestion.indexOf('Condition of lid') > -1 || selectedQuestion.indexOf('Is there an effluent filter') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'lid_condition' || el.questionReference == 'lid_cond_aeration' || el.questionReference == 'eff_filter_present' 
        || el.questionReference == 'lid_condition_scnd') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Sat" || selectedAnswer == "No") {
          switch (el.questionReference) {
            case 'lid_condition_unsat':
            case 'lid_unsat_aeration':
            case 'lid_condition_unsat_single':
            case 'septic_tank_filter_size':
            case 'poly_filter_size':
            case 'septic_tank_filter_type':
            case 'lid_at_grade':
            case 'lid_condition_unsat_scnd':
            case 'filter_cleaned':
            case 'condition_of_effluent_filter':
            case 'reason_for_unsat':
            case 'reason_for_unsat_filter':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
            case 'lid_photo':
            case 'lid_scnd_photo':
              el.disableFlag = true;
              el.hideElement = false;
              break;
            case 'service_prgm_candidate':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
          }
        } else if (selectedAnswer == "Unsat" || selectedAnswer == "Yes") {
          switch (el.questionReference) {
            case 'lid_condition_unsat':
            case 'lid_unsat_aeration':
            case 'lid_condition_unsat_single':
            case 'septic_tank_filter_size':
            case 'poly_filter_size':
            case 'septic_tank_filter_type':
            case 'lid_at_grade':
            case 'lid_condition_unsat_scnd':
            case 'filter_cleaned':
            case 'condition_of_effluent_filter':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
            case 'lid_photo':
            case 'lid_scnd_photo':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'service_prgm_candidate':
            case 'no_why':
            case 'out_baf_opening':
            case 'type_of_filter':
            case 'filter_size':
            case 'poly_fil_size':
            case 'baf_extension_accessible':
            case 'replacement_baf_size':
            case 'no_why':
            case 'filter_install':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;

          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Riser condition') > -1 || selectedQuestion.indexOf('Is the system a candidate for service program') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'riser_condition' || el.questionReference == 'service_prgm_candidate' || el.questionReference == 'riser_condition_single' || el.questionReference == 'riser_condition_scnd' || el.questionReference == 'riser_cond_aeration') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Sat" || selectedAnswer == "No") {
          switch (el.questionReference) {
            case 'riser_cond_unsat':
            case 'riser_unsat_aeration':
            case 'riser_unsat_photo':
            case 'riser_cond_unsat_single':
            case 'riser_cond_unsat_scnd':
            case 'riser_unsat_scnd_photo':
            case 'out_baf_opening':
            case 'type_of_filter':
            case 'filter_size':
            case 'poly_fil_size':
            case 'baf_extension_accessible':
            case 'replacement_baf_size':
            case 'riser_lid_needed_access':
            case 'lid_diameter_single':
            case 'lid_diameter_single_add':
            case 'lid_diameter_single_add1':
            case 'filter_riser_height_single_add1':
            case 'is_a_riser_needed':
            case 'filter_riser_height_single':
            case 'filter_riser_height_single_add':
            case 'lid_diameter_double':
            case 'filter_riser_height_double':
            case 'filter_install':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
            case 'service_prgm_candidate':
            case 'no_why':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
          }
        } else if (selectedAnswer == "Unsat" || selectedAnswer == "Yes") {
          switch (el.questionReference) {
            case 'riser_cond_unsat':
            case 'riser_unsat_aeration':
            case 'riser_cond_unsat_single':
            case 'riser_cond_unsat_scnd':
            case 'out_baf_opening':
            case 'type_of_filter':
            case 'filter_size':
            case 'poly_fil_size':
            case 'baf_extension_accessible':
            case 'replacement_baf_size':
            case 'riser_lid_needed_access':
            case 'lid_diameter_single':
            case 'lid_diameter_single_add':
            case 'lid_diameter_single_add1':
            case 'filter_riser_height_single':
            case 'is_a_riser_needed':
            case 'filter_riser_height_single_add':
            case 'filter_riser_height_single_add1':
            case 'lid_diameter_double':
            case 'filter_riser_height_double':
            case 'filter_install':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
            case 'riser_unsat_photo':
            case 'riser_unsat_scnd_photo':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'no_why':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;

          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Is there a riser') > -1 || selectedQuestion.indexOf('Is the outlet baffle fully accessible for maintenance') > -1
      || selectedQuestion.indexOf('CORNER PORTS AT GRADE') > -1 || selectedQuestion.indexOf('Additional gallons pumped over 500') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'riser' || el.questionReference == 'riser1' || el.questionReference == 'out_baf_opening' || el.questionReference == 'riser_single' || el.questionReference == 'riser_scnd' || el.questionReference == 'corner_ports_drain_field_scnd' || el.questionReference == 'additional_pump_gallon'
          || el.questionNumber == 'riser_aeration') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Yes" || selectedAnswer == "yes") {
          switch (el.questionReference) {
            case 'riser_height':
            case 'riser_depth_trash':
            case 'riser_diameter':
            case 'riser_depth_aeration':
            case 'riser_diameter_aeration':
            case 'riser_height_single':
            case 'riser_height_scnd':
            case 'riser_type_hei_fst_double':
            case 'riser_type_hei_scnd_double':
            case 'riser_type_hei':
            case 'riser_type_hei_aeration':
            case 'riser_condition':
            case 'riser_cond_aeration':
            case 'riser_condition_scnd':
            case 'no_of_corner_ports_scnd':
            case 'water_ins_port_scnd':
            case 'how_many_add_pump_gallon':
            case 'additional_gallons_reason':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
            case 'riser_unsat_photo':
            case 'riser_unsat_scnd_photo':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'riser_depth':
            case 'riser_depth_single':
            case 'riser_depth_scnd':
            case 'baf_extension_accessible':
            case 'riser_lid_needed_access':
            case 'lid_diameter_single':
            case 'lid_diameter_double':
            case 'filter_riser_height_single':
            case 'filter_riser_height_double':
            case 'is_a_riser_needed':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        } else if (selectedAnswer == "No" || selectedAnswer == "no") {
          switch (el.questionReference) {
            case 'riser_height':
            case 'riser_depth_trash':
            case 'riser_diameter':
            case 'riser_depth_aeration':
            case 'riser_diameter_aeration':
            case 'riser_height_single':
            case 'riser_height_scnd':
            case 'riser_type_hei':
            case 'riser_type_hei_aeration':
            case 'riser_type_hei_fst_double':
            case 'riser_type_hei_scnd_double':
            case 'riser_condition_scnd':
            case 'riser_condition':
            case 'riser_cond_aeration':
            case 'riser_cond_unsat':
            case 'riser_unsat_aeration':
            case 'riser_cond_unsat_scnd':
            case 'no_of_corner_ports_scnd':
            case 'water_ins_port_scnd':
            case 'how_many_add_pump_gallon':
            case 'additional_gallons_reason':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
            case 'riser_unsat_photo':
            case 'riser_unsat_scnd_photo':
              el.disableFlag = true;
              el.hideElement = false;
              break;
            case 'riser_depth':
            case 'riser_depth_single':
            case 'riser_depth_scnd':
            case 'baf_extension_accessible':
            case 'riser_lid_needed_access':
            case 'lid_diameter_single':
            case 'lid_diameter_double':
            case 'filter_riser_height_single':
            case 'filter_riser_height_double':
            case 'is_a_riser_needed':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;

          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Is a filter lid needed') > -1
      || selectedQuestion.indexOf('Is there a pump tank available') > -1 || selectedQuestion.indexOf('Digging charge') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'riser_lid_needed_access' || el.questionReference == 'pump_tank' || el.questionReference == 'dig_charge' || el.questionReference == 'dig_charge_scnd') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Yes") {
          switch (el.questionReference) {
            case 'lid_diameter_single':
            case 'lid_diameter_single_add':
            case 'filter_riser_height_single_add':
            case 'lid_diameter_single_add1':
            case 'filter_riser_height_single_add1':
            case 'lid_diameter_double':
            case 'filter_riser_height_double':
            case 'pump_tank_loc':
            case 'pump_tank_loc1':
            case 'lid_grade_pump':
            case 'lid_grade_pump1':
            case 'pump_out':
            case 'additional_pump_gallon':
            case 'add_gallon':
            case 'how_much_gallon':
            case 'how_many_foot':
            case 'how_many_foot_scnd':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
            case 'pump_tank_loc_photo':
            case 'pump_tank_loc_photo1':
              el.disableFlag = false;
              el.hideElement = true;
              break;
          }
        } else if (selectedAnswer == "No") {
          switch (el.questionReference) {
            case 'lid_diameter_single':
            case 'lid_diameter_single_add':
            case 'filter_riser_height_single_add':
            case 'lid_diameter_single_add1':
            case 'filter_riser_height_single_add1':
            case 'lid_diameter_double':
            case 'pump_tank_loc':
            case 'pump_tank_loc1':
            case 'lid_grade_pump':
            case 'lid_grade_pump1':
            case 'pump_out':
            case 'additional_pump_gallon':
            case 'how_many_add_pump_gallon':
            case 'additional_gallons_reason':
            case 'add_gallon':
            case 'how_much_gallon':
            case 'dig_charge_greater':
            case 'how_many_foot':
            case 'how_many_foot_scnd':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
            case 'pump_tank_loc_photo':
            case 'pump_tank_loc_photo1':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('CONDITION OF LID') > -1 || selectedQuestion.indexOf('CONDITION OF ACCESS LID') > -1 || selectedQuestion.indexOf('Extra hose per foot in addition to 4 hose(100ft)') > -1
         || selectedQuestion.indexOf('Will a filter slide into existing baffle') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'lid_cond_pump' || el.questionReference == 'lid_condition_peat_moss' || el.questionReference == 'extra_hose' || el.questionReference == 'filter_install') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Sat" || selectedAnswer == 'No') {
          switch (el.questionReference) {
            case 'lid_cond_unsat_pump':
            case 'lid_cond_unsat_vault':
            case 'lid_unsat_reason_peat_moss':
            case 'how_many_hose':
            case 'reason_for_additional_hose':
            case 'type_of_filter':
            case 'filter_size':
            case 'poly_fil_size':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
            case 'replacement_baf_size':
            case 'baf_extension_accessible':
              el.disableFlag = false;;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        } else if (selectedAnswer == "Unsat" || selectedAnswer == 'Yes') {
          switch (el.questionReference) {
            case 'lid_cond_unsat_pump':
            case 'lid_cond_unsat_vault':
            case 'lid_unsat_reason_peat_moss':
            case 'how_many_hose':
            case 'reason_for_additional_hose':
            case 'type_of_filter':
            case 'filter_size':
            case 'poly_fil_size':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
            case 'replacement_baf_size':
            case 'baf_extension_accessible':
              el.disableFlag = true;;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Single compartment lid') > -1 || selectedQuestion.indexOf('First compartment lid') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'lid_location_single' || el.questionReference == 'lid_location_fst_double') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Buried") {
          switch (el.questionReference) {
            case 'dig_charge':
            case 'how_many_foot':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        } else if (selectedAnswer == "Exposed") {
          switch (el.questionReference) {
            case 'dig_charge':
            case 'how_many_foot':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Second compartment lid') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'lid_location_scnd_double') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Buried") {
          switch (el.questionReference) {
            case 'dig_charge_scnd':
            case 'how_many_foot_scnd':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        } else if (selectedAnswer == "Exposed") {
          switch (el.questionReference) {
            case 'dig_charge_scnd':
            case 'how_many_foot_scnd':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Liquid level') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'liquid_level_trash' || el.questionReference == 'liquid_level_aeration') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Unsat") {
          switch (el.questionReference) {
            case 'liquid_level_unsat_trash':
            case 'liquid_level_unsat_aeration':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        } else if (selectedAnswer == "Sat") {
          switch (el.questionReference) {
            case 'liquid_level_unsat_trash':
            case 'liquid_level_unsat_aeration':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Aeration chamber water level') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'water_level') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Unsat") {
          switch (el.questionReference) {
            case 'water_level_unsat':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        } else if (selectedAnswer == "Sat") {
          switch (el.questionReference) {
            case 'water_level_unsat':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('How many functional drain fields are there') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'how_many_drain_field') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "1") {
          switch (el.questionReference) {
            case 'scnd_drain_field':
            case 'drain_field_location_scnd':
            case 'drain_field_type_scnd':
            case 'corner_ports_drain_field_scnd':
            case 'drain_field_conn_by':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        } else if (selectedAnswer == "2") {
          switch (el.questionReference) {
            case 'scnd_drain_field':
            case 'drain_field_location_scnd':
            case 'drain_field_type_scnd':
            case 'corner_ports_drain_field_scnd':
            case 'drain_field_conn_by':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Aeration chamber water level') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'water_level') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Unsat") {
          switch (el.questionReference) {
            case 'water_level_unsat':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        } else if (selectedAnswer == "Sat") {
          switch (el.questionReference) {
            case 'water_level_unsat':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Is there a sewer line clean out') > -1 || selectedQuestion.indexOf('Is there an accessible lid at grade for service') >-1 || selectedQuestion.indexOf('Was Aeration chamber pumped') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'lid_at_grade' || el.questionReference == 'sewer_line_clean_out' || el.questionReference == 'scnd_sys_sewer_line_clean_out' || el.questionReference == 'aeration_chamber_pumped') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'No') {
          switch (el.questionReference) {
            case 'clean_out_location':
            case 'scnd_sys_clean_out_location':
            case 'sewer_line_length':
            case 'scnd_sys_sewer_line_length':
            case 'gallons_pumped_aeration':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
            case 'exterior_pump':
            case 'exterior_vault':
            case 'no_ of_corner_ports':
            case 'riser_lid_needed_access':
            case 'lid_diameter_single':
            case 'is_a_riser_needed':
            case 'filter_riser_height_single':
            case 'lid_diameter_double':
            case 'filter_riser_height_double':
            case 'aeration_chamber_pumped_reason':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        } else if (selectedAnswer == 'Yes') {
          switch (el.questionReference) {
            case 'exterior_pump':
            case 'exterior_vault':
            case 'no_of_corner_ports':
            case 'riser_lid_needed_access':
            case 'lid_diameter_single':
            case 'is_a_riser_needed':
            case 'filter_riser_height_single':
            case 'lid_diameter_double':
            case 'filter_riser_height_double':
            case 'aeration_chamber_pumped_reason':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
            case 'interior_pump':
            case 'interior_vault':
            case 'clean_out_location':
            case 'scnd_sys_clean_out_location':
            case 'sewer_line_length':
            case 'scnd_sys_sewer_line_length':
            case 'gallons_pumped_aeration':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Condition of effluent filter') > -1 || selectedQuestion.indexOf('Additional gallons over tank size') > -1 || selectedQuestion.indexOf('Condition of ports') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'condition_of_effluent_filter' || el.questionReference == 'add_gallon' || el.questionReference == 'ports_condition' || el.questionReference == 'if_yes_cond_of_ports' || el.questionReference == 'if_yes_cond_of_ports_scnd') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Sat' || selectedAnswer == 'No' || selectedAnswer == 'Unknown') {
          switch (el.questionReference) {
            case 'reason_for_unsat':
            case 'reason_for_unsat_filter':
            case 'reason_for_unsat_scnd':
            case 'how_much_gallon':
            case 'unsat_ports':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        } else if (selectedAnswer == 'Unsat' || selectedAnswer == 'Yes') {
          switch (el.questionReference) {
            case 'reason_for_unsat':
            case 'reason_for_unsat_filter':
            case 'reason_for_unsat_scnd':
            case 'how_much_gallon':
            case 'unsat_ports':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Shape of tank') > -1 || selectedQuestion.indexOf('If there is a pump tank, was it pumped')> -1 || selectedQuestion.indexOf('Is a riser needed') >-1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'shape_of_tank' || el.questionReference == 'tank_shape_double' || el.questionReference == 'pump_out' || el.questionReference == 'is_a_riser_needed') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Yes' || selectedAnswer == 'Round') {
          switch (el.questionReference) {
            case 'diameter_of_tank':
            case 'depth_of_tank':
            case 'additional_pump_gallon':
            case 'how_many_add_pump_gallon':
            case 'additional_gallons_reason':
            case 'add_gallon':
            case 'how_much_gallon':
            case 'filter_riser_height_single':
            case 'filter_riser_height_double':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
            case 'divider_wall':
            case 'length_of_tank':
            case 'width_of_tank':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        } else if (selectedAnswer == 'No' || selectedAnswer == 'Rectangle') {
          switch (el.questionReference) {
            case 'diameter_of_tank':
            case 'additional_pump_gallon':
            case 'how_many_add_pump_gallon':
            case 'additional_gallons_reason':
            case 'add_gallon':
            case 'how_much_gallon':
            case 'filter_riser_height_single':
            case 'filter_riser_height_double':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
            case 'divider_wall':
            case 'depth_of_tank':
            case 'length_of_tank':
            case 'width_of_tank':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if(selectedQuestion.indexOf('Does the tank have ports') > -1 || selectedQuestion.indexOf('Trash compartment lid') > -1 || selectedQuestion.indexOf('Aeration Lid') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'ports' || el.questionReference == 'does_tank_have_ports' || el.questionReference == 'does_tank_have_ports_scnd' || el.questionReference == 'trash_compartment_lid' || el.questionReference == 'aeration_lid') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Yes' || selectedAnswer == 'Buried') {
          switch (el.questionReference) {
            case 'ports_condition':
            case 'if_yes_cond_of_ports':
            case 'if_yes_cond_of_ports_scnd':
            case 'lid_buried':
            case 'lid_buried_aeration':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        } else if (selectedAnswer == 'No' || selectedAnswer == 'Exposed') {
          switch (el.questionReference) {
            case 'ports_condition':
            case 'unsat_ports':
            case 'reason_for_unsat':
            case 'reason_for_unsat_scnd':
            case 'if_yes_cond_of_ports':
            case 'if_yes_cond_of_ports_scnd':
            case 'lid_buried':
            case 'lid_buried_aeration':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if(!event?.mobileView) {
      this.ServiceQuestionUpdate(event.detail.value, index);
    }
    // this.ServiceQuestionUpdate(event.detail.value, index);
  }

  dropdownOnchange = (event: any, index: number) => {
    //Logics to hide & disable questions based on dropdown question and answer choosen
    // if (!event?.detail?.value) return;
    const updateEvent = this.state.data as Question[];
    let selectedQuestion = event?.target?.ariaLabel;
    let selectedAnswer = event?.detail?.value;
    if(event?.mobileView) {
      selectedQuestion = event.mobileView;
      selectedAnswer = event.answer;
    }
    if(updateEvent[index].questionReference == 'reason_for_volume_difference' && (this.state.headerTO.pumpoutType == 'New Pumpout Customer' || this.state.headerTO.pumpoutType == 'Pumpout Customer')) {
      if((updateEvent[index - 2].answer != updateEvent[index - 1].answer) && selectedAnswer != 'Records are incorrect') {
        updateEvent[index + 1].disableFlag = true;
        updateEvent[index + 1].mandatory = false;
        updateEvent[index + 2].disableFlag = true;
        updateEvent[index + 2].mandatory = false;
        updateEvent[index + 3].disableFlag = true;
        updateEvent[index + 3].mandatory = false;
        updateEvent[index + 4].disableFlag = true;
        updateEvent[index + 4].mandatory = false;
        updateEvent[index + 5].disableFlag = true;
        updateEvent[index + 5].mandatory = false;
        updateEvent[index + 6].disableFlag = true;
        updateEvent[index + 6].mandatory = false;
        updateEvent[index + 7].disableFlag = true;
        updateEvent[index + 7].mandatory = false;
      } else if(updateEvent[index - 2].answer == updateEvent[index - 1].answer) {
        updateEvent[index + 1].disableFlag = true;
        updateEvent[index + 1].mandatory = false;
        updateEvent[index + 2].disableFlag = true;
        updateEvent[index + 2].mandatory = false;
        updateEvent[index + 3].disableFlag = true;
        updateEvent[index + 3].mandatory = false;
        updateEvent[index + 4].disableFlag = true;
        updateEvent[index + 4].mandatory = false;
        updateEvent[index + 5].disableFlag = true;
        updateEvent[index + 5].mandatory = false;
        updateEvent[index + 6].disableFlag = true;
        updateEvent[index + 6].mandatory = false;
        updateEvent[index + 7].disableFlag = true;
        updateEvent[index + 7].mandatory = false;
      } else {
        updateEvent[index + 1].disableFlag = false;
        updateEvent[index + 1].mandatory = true;
        updateEvent[index + 2].disableFlag = false;
        updateEvent[index + 2].mandatory = true;
        updateEvent[index + 3].disableFlag = false;
        updateEvent[index + 3].mandatory = true;
        updateEvent[index + 4].disableFlag = false;
        updateEvent[index + 4].mandatory = true;
        updateEvent[index + 5].disableFlag = false;
        updateEvent[index + 5].mandatory = true;
        updateEvent[index + 6].disableFlag = false;
        updateEvent[index + 6].mandatory = true;
        updateEvent[index + 7].disableFlag = false;
        updateEvent[index + 7].mandatory = true;
      }
    }
    if (selectedQuestion.indexOf('SEPTIC TANK SIZE (gals.)') > -1 || selectedQuestion.indexOf('Proposed slide in type') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'septic_tank_size' || el.questionReference == 'type_of_filter') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Other" || selectedAnswer == 'Poly') {
          switch (el.questionReference) {
            case 'septic_tank_size_other':
            case 'septic_tank_size_other_add':
            case 'poly_fil_size':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
            case 'filter_size':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        } else if (selectedAnswer == 'Bristle') {
          switch (el.questionReference) {
            case 'septic_tank_size_other':
            case 'septic_tank_size_other_add':
            case 'poly_fil_size':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
            case 'filter_size':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;

          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }

    if (selectedQuestion.indexOf('SIZE OF LID') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'size_lid' || el.questionReference == 'size_lid_scnd_double'
          || el.questionReference == 'size_lid_pump' || el.questionReference == 'size_lid_vault') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Other") {
          switch (el.questionReference) {
            case 'lid_size':
            case 'lid_size1':
            case 'type_size_lid_pump':
            case 'type_size_lid_vault':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        } else {
          switch (el.questionReference) {
            case 'lid_size':
            case 'lid_size1':
            case 'type_size_lid_pump':
            case 'type_size_lid_vault':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Condition of inlet baffle') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'inlet_baffle' || el.questionReference == 'inlet_baffle_scnd') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Unsat') {
          switch (el.questionReference) {
            case 'inlet_unsat_reason':
            case 'scnd_inlet_unsat_reason':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        } else {
          switch (el.questionReference) {
            case 'inlet_unsat_reason':
            case 'scnd_inlet_unsat_reason':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('TYPE OF FILTER') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'septic_tank_filter_type') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Poly") {
          switch (el.questionReference) {
            case 'poly_filter_size':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'septic_tank_filter_size':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer == 'Bristle') {
          switch (el.questionReference) {
            case 'septic_tank_filter_size':
            case 'drain_field_type':
            case 'corner_ports_drain_field':
            case 'how_many_drain_field':
            case 'drain_field_type_scnd':
            case 'corner_ports_drain_field_scnd':
            case 'drain_field_conn_by':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'poly_filter_size':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Condition of outlet baffle') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'outlet_baffle' || el.questionReference == 'outlet_baffle_aeration' || el.questionReference == 'outlet_baffle_scnd') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Sat" || selectedAnswer == 'Unknown/ Not Visible') {
          switch (el.questionReference) {
              case 'outlet_unsat_reason':
              case 'outlet_unsat_aeration':
              case 'scnd_outlet_unsat_reason':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        } else if (selectedAnswer == 'Unsat') {
          switch (el.questionReference) {
              case 'outlet_unsat_reason':
              case 'outlet_unsat_aeration':
              case 'scnd_outlet_unsat_reason':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Manufacturer of aerobic unit') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'manufacturer') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Hoot') {
          switch (el.questionReference) {
              case 'models':
              el.disableFlag = false;
              el.mandatory = true;
              break;
          }
        } else if (selectedAnswer != 'Hoot') {
          switch (el.questionReference) {
              case 'models':
              el.disableFlag = true;
              el.mandatory = false;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Lid is made of') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'lid_type_size' || el.questionReference == 'lid_type_size_fst_double' || el.questionReference == 'lid_type_size_scnd_double' || el.questionReference == 'lid_type_size_aeration') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Concrete') {
          switch (el.questionReference) {
            case 'bolt_size_lid':
            case 'bolt_size_fst_lid':
            case 'bolt_size_scnd_lid':
            case 'bolt_size_lid_aeration':
            case 'tool_used':
            case 'tool_used_fst_lid':
            case 'tool_used_scnd_lid':
            case 'tool_used_aeration':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        } else {
          switch (el.questionReference) {
            case 'bolt_size_lid':
            case 'bolt_size_lid_aeration':
            case 'bolt_size_fst_lid':
            case 'bolt_size_scnd_lid':
            case 'tool_used':
            case 'tool_used_fst_lid':
            case 'tool_used_scnd_lid':
            case 'tool_used_aeration':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Bolt size for lid') > -1 || selectedQuestion.indexOf('Bolt size for first lid') > -1 || selectedQuestion.indexOf('Bolt size for second lid') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'bolt_size_lid'  || el.questionReference == 'bolt_size_lid_aeration' || el.questionReference == 'bolt_size_fst_lid'  || el.questionReference == 'bolt_size_scnd_lid') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer != "Unknown" && selectedAnswer != 'N/A') {
          switch (el.questionReference) {
            case 'tool_used':
            case 'tool_used_fst_lid':
            case 'tool_used_scnd_lid':
            case 'tool_used_aeration':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        } else {
          switch (el.questionReference) {
            case 'tool_used':
            case 'tool_used_fst_lid':
            case 'tool_used_scnd_lid':
            case 'tool_used_aeration':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Interior of tank') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'tank_condition_atu' || el.questionReference == 'tank_condition') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Unsat") {
          switch (el.questionReference) {
            case 'tank_cond_unsat':
            case 'tank_cond_unsat_atu':
            case 'location_of_unsat_conditions':
            case 'location_of_unsat_conditions_scnd':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
            case 'tank_unsat_photo':
              el.disableFlag = false;
              el.hideElement = true;
              break;
          }
        } else if(selectedAnswer == 'Sat' || selectedAnswer == 'Unknown/ Not Visible') {
          switch (el.questionReference) {
            case 'tank_cond_unsat':
            case 'tank_cond_unsat_atu':
            case 'location_of_unsat_conditions':
            case 'location_of_unsat_conditions_scnd':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
            case 'tank_unsat_photo':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('Location of drain field') > -1) {
      updateEvent.map((el: Question) => {
        if (el.questionReference == 'drain_field_location') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == 'Unknown') {
          switch (el.questionReference) {
            case 'drain_field_type':
            case 'corner_ports_drain_field':
            case 'how_many_drain_field':
            case 'scnd_drain_field':
            case 'drain_field_location_scnd':
            case 'drain_field_type_scnd':
            case 'corner_ports_drain_field_scnd':
            case 'how_many_drain_field':
            case 'drain_field_conn_by':
              el.disableFlag = true;
              el.hideElement = false;
              el.mandatory = false;
              break;
          }
        } else if (selectedAnswer != 'Unknown') {
          switch (el.questionReference) {
            case 'drain_field_type':
            case 'corner_ports_drain_field':
            case 'how_many_drain_field':
            case 'scnd_drain_field':
            case 'drain_field_location_scnd':
            case 'drain_field_type_scnd':
            case 'corner_ports_drain_field_scnd':
            case 'how_many_drain_field':
            case 'drain_field_conn_by':
              el.disableFlag = false;
              el.hideElement = true;
              el.mandatory = true;
              break;
          }
        }
      });
      this.setState({
        data: updateEvent
      });
    }
    if(!event?.mobileView) {
      this.ServiceQuestionUpdate(event.detail.value, index);
    }
      // this.ServiceQuestionUpdate(event.detail.value, index);
  }

  dropdownMultiOnchange = (event: any, index: number) => {
    //To save selected checkbox event values
    const val = event.detail.value;
    const finalvalue = val.toString();
    console.log("finalvalue=", finalvalue)
    this.ServiceQuestionUpdate(finalvalue, index);
  }

  ionViewWillEnter() {
    console.log('ionViewWillEnter event fired')
  }

  ionViewWillLeave() {
    console.log('ionViewWillLeave event fired')
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter event fired')
  }

  ionViewDidLeave() {
    console.log('ionViewDidLeave event fired')
  }

  async takePhoto(index: number) {

    const formdata = CAMERA();
    this.uploadImage(await formdata, this.selectedData.id, index);
  }

  //Upload Captured Image
  uploadImage(formData: FormData, id: number, index: number) {
    const customerId = this.props.location.state.userData.propertyId;
    const townshipId = this.props.location.state.userData.townshipId;
    const moduleNumber = this.state.pumpoutDetailsTO.moduleNumber;
    const compartmentType = this.state.data[index].compartmentType;
    const questionReference = this.state.data[index].questionReference;
    const type = "pumpout";
    const uploadRequest = API.authPostRequest(apiConstants.photoUploadUrl + id + '&customerId=' + customerId + '&townshipId=' + townshipId + '&type=' + type  + '&moduleNumber=' + moduleNumber + '&compartment=' + compartmentType + '&questionReference=' + questionReference, formData);
    uploadRequest
      .then(async () => {
        console.log('ImageUploaded Successfully');
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Convert base64 to blob
  base64ToImage(dataURI: String) {
    const fileDate = dataURI.split(',');
    const byteString = atob(fileDate[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([arrayBuffer], { type: 'image/png' });
    return blob;
  }

  viewPhoto = (index : number) => {
    
    const townshipId= this.props.location.state.userData.townshipId;
    const customerId= this.props.location.state.userData.customerId;
    const questionReference = this.state.data[index].questionReference;
    const viewPhotos = apiConstants.viewPhoto + townshipId + '&customerId=' + customerId + '&questionReference=' + questionReference;
    //if(questionReference === this.state.photo[questionReference]) { // If image maintain in state then same call will not have next
      API.authGetRequest(viewPhotos, '')
        .then((res) => {
          if(res.data) {
            const photoObj = Object.assign({}, {[this.state.data[index]?.questionReference]: res?.data}, this.state.photo);
            this.setState({ photo: photoObj });
          }
      })
     
  }

  render() {
    const { name } = this.state;
    const { key } = this.state;
    return (
      <InsPage>
        <IonPage key = {key}>
          <IonHeader>
            <IonToolbar>
              <IonRow>
                <IonCol size="4" >
                  <IonItem lines="none" onClick={this.goBack} >
                    <IonIcon color="primary" slot="start" icon={chevronBackSharp} style={{ fontSize: "40px", paddingTop: "10px" }} />
                  </IonItem>
                </IonCol>
                <IonCol className="ion-align-self-center" style={{ textAlign: "justify" }}>
                  <img src="assets/logo001.png" width="40%" />
                </IonCol> 

                <LogoutPage />

              </IonRow>
            </IonToolbar>
            <IonToolbar color="secondary">

              <IonTitle>Powered By:<span><b>Septic Smart</b></span></IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent fullscreen>

            <IonCard style={{ borderTop: "4px solid #53A658" }}>
              <IonCardHeader style={{ textAlign: "center" }}>
              <div style={{ textAlign: "center" }}>
                <IonTitle className="iontitle"><b>{this.state?.headerTO?.title}</b> </IonTitle>
                </div>
                <div style={{textAlign: "right"}}>
                <em style = {{color : 'red'}}>*</em><em className = "mandatory"> indicates mandatory field</em>
                </div>
              </IonCardHeader>

              {(this.state.data.map((user: any, index: number) => (
                <IonCardContent key={index} className="card_content">

                  {(user.answerType === 'text' && user.hideElement) ?
                    <IonRow>
                      <IonCol>
                        <IonItem>
                          <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView}</b></IonLabel>
                          <IonInput className="ion-text-wrap" style={{ color: "#019849", fontWeight: "bold" }} value={user.answer} disabled={user.disableFlag} onIonChange={e => { this.textOnchange(e.detail.value, index) }}></IonInput>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'textStatic' && user.staticQuestionReference == null) ?
                    <IonRow>
                      <IonCol>
                      {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN')) ?
                          <IonLabel color="danger">
                            <b>{user.mandatoryText}</b>
                          </IonLabel>
                        : null}
                        <form>
                          <IonItem>
                          <><IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null}</b></IonLabel> <IonLabel style={{ color: "#019849", fontWeight: "bold", textAlign: "end" }}> {user.answer} </IonLabel></>
                          </IonItem>
                        </form>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'textStatic' && user.staticQuestionReference != null) ?
                    <IonRow>
                      <IonCol>
                        {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN')) ?
                          <IonLabel color="danger">
                            <b>{user.mandatoryText}</b>
                          </IonLabel>
                          : null}
                        <form>
                          <IonItem>
                            <><IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style={{ color: 'red', fontWeight: 'bold' }}>*</sup> : null}</b></IonLabel> <IonLabel className='color' style={{ textAlign: "end" }}> {user.answer} </IonLabel></>
                          </IonItem>
                        </form>
                      </IonCol>
                    </IonRow>
                    : null}


                  {(user.answerType === 'textChange') ?
                    <IonRow>
                      <IonCol>
                      {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN')) ?
                          <IonLabel color="danger">
                            <b>{user.mandatoryText}</b>
                          </IonLabel>
                        : null}
                        <form>
                          <IonItem disabled={user.disableFlag}>
                            <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null}</b></IonLabel>
                            <IonInput className="ion-text-wrap" style={{ color: "#019849", fontWeight: "bold" }} onKeyPress={this.handleKeyPress} value={user.answer} disabled={user.disableFlag} onIonChange={e => { this.textOnChange(e.detail.value, index) }}></IonInput>
                          </IonItem>
                        </form>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'calculateValues') ?
                    <IonRow>
                      <IonCol>
                        <form>
                          <IonItem disabled={user.disableFlag}>
                            {(() => {
                              if (this.state.pumpOutQuestion.pumpOutQuestionTOs[index - 6].answer == 'Round') {
                                let diameter = this.state.data[index - 4].answer - 6;
                                let radius = diameter / 2;
                                let height = this.state.data[index - 3].answer;
                                let labelAnswer = (3.14159 * radius * radius * height) / 231;
                                let roundOff = Math.round(labelAnswer);
                                if (roundOff >= 900 && roundOff <= 1160) {
                                  roundOff = 1000;
                                } else if (roundOff > 1160 && roundOff <= 1270) {
                                  roundOff = 1250;
                                } else if (roundOff > 1270 && roundOff <= 1400) {
                                  roundOff = 1300;
                                } else if (roundOff > 1400 && roundOff <= 1625) {
                                  roundOff = 1500;
                                } else if (roundOff > 1625 && roundOff <= 1875) {
                                  roundOff = 1750;
                                } else if (roundOff > 1875) {
                                  roundOff = 2000;
                                }
                                this.state.pumpOutQuestion.pumpOutQuestionTOs[index].answer = roundOff;
                                return (
                                  <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView}</b> &nbsp; <IonBadge>{roundOff + ' gal'}</IonBadge></IonLabel>
                                )
                              }

                              if (this.state.pumpOutQuestion.pumpOutQuestionTOs[index - 6].answer == 'Rectangle') {
                                let length = null;
                                if (this.state.pumpOutQuestion.pumpOutQuestionTOs[index - 5].answer == 'Yes') {
                                  length = this.state.data[index - 2].answer - 9;
                                } else {
                                  length = this.state.data[index - 2].answer - 6;
                                }
                                let breadth = this.state.data[index - 1].answer - 6;
                                let height = this.state.data[index - 3].answer;
                                let labelAnswer = (length * breadth * height) / 231;
                                let roundOff = Math.round(labelAnswer);
                                if (roundOff >= 900 && roundOff <= 1160) {
                                  roundOff = 1000;
                                } else if (roundOff > 1160 && roundOff <= 1270) {
                                  roundOff = 1250;
                                } else if (roundOff > 1270 && roundOff <= 1400) {
                                  roundOff = 1300;
                                } else if (roundOff > 1400 && roundOff <= 1625) {
                                  roundOff = 1500;
                                } else if (roundOff > 1625 && roundOff <= 1875) {
                                  roundOff = 1750;
                                } else if (roundOff > 1875) {
                                  roundOff = 2000;
                                }
                                this.state.pumpOutQuestion.pumpOutQuestionTOs[index].answer = roundOff;
                                return (
                                  <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView}</b> &nbsp; <IonBadge>{roundOff + ' gal'}</IonBadge></IonLabel>
                                )
                              }
                            })()}
                          </IonItem>
                        </form>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'Main Heading') ?
                    <IonRow>
                      <IonCol>
                        <IonItem>
                          <IonLabel className="iontitle"><b>{user.questionNumber} {user.mobileView}</b></IonLabel>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.questionReference == 'reason_for_cancellation' || user.questionReference == 'comments_any') ?
                    <IonRow>
                      <IonCol>
                        <IonItem>
                          <label style={{ color: '#000000' }}><b>{user.questionNumber} {user.mobileView}</b></label>
                          <textarea className="text-wrap" value={user.answer} style={{ marginLeft: '10%', display: 'flex', width: "50%", height: "100px" }} placeholder="Please Type Here..." onChange={e => { this.textOnchange(e.target.value, index) }}></textarea>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                   {(user.answerType === 'take photo' && (user.hideElement || user.hideElement == undefined )) ?
                    <IonRow>
                      <IonCol>
                        <IonItem disabled={user.disableFlag}>
                          <IonLabel className="app-font" style={{ paddingLeft: '5px'}}><b>{user.questionNumber} {user.mobileView}</b></IonLabel>
                          <IonThumbnail slot = "start" style = {{width : 200, height : 200}}>
                                <IonImg src={'data:image/png;base64,' + this.state.photo[user.questionReference]} onIonImgWillLoad={() => this.viewPhoto(index)}></IonImg>
                            </IonThumbnail>
                          <IonFab horizontal="end">
                            <IonFabButton disabled={user.disableFlag}>
                              <IonIcon style={{ fontSize: "w3-tiny" }} icon={camera} onClick={() => this.takePhoto(index)} />
                            </IonFabButton>
                          </IonFab>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'photo') ?
                    <IonRow>
                      <IonCol>
                        <IonItem disabled={user.disableFlag}>
                          <IonLabel className="app-font" style={{ paddingLeft: '5px'}}><b>{user.questionNumber} {user.mobileView}</b></IonLabel>
                          <IonFab horizontal="end">
                            <IonFabButton disabled={user.disableFlag}>
                              <IonIcon style={{ fontSize: "w3-tiny" }} icon={camera} onClick={() => this.takePhoto(index)} />
                            </IonFabButton>
                          </IonFab>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType == 'audio') ?
                    <IonRow>
                      <IonCol>
                        <IonItem>
                          <label style={{ color: '#000000' }}> <b>{user.questionNumber} {user.mobileView}</b> &nbsp;</label>
                          <AudioRecoder parentCallback={this.handleCallback} />
                          {name}
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                    {((user.answerType == 'radio' && user.preFill == 'No' && user.staticQuestionReference == null) || (user.answerType =='radio' && user.preFill == 'Yes' && user.answer == null && user.staticQuestionReference == null) || (user.answerType == 'radio' && user.preFill == 'Yes' && user.answer != null && user.staticQuestionReference == null))?
                    <IonRow>
                      <IonCol>
                      {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN')) ?
                          <IonLabel color="danger">
                            <b>{user.mandatoryText}</b>
                          </IonLabel>
                        : null}
                        <IonItem disabled={user.disableFlag}>
                          <IonRadioGroup className="app-font" value={user.answer} style={{ display: "flex" }} onIonChange={e => { this.radioOnchange(e, index) }}>
                            <IonLabel className="app-font"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null}</b></IonLabel>
                            {user.answerValue.split(',').map((el: string, k: number) => (
                              <IonItem key={k} className="ion-item-top-adjust">
                                <IonLabel className='text-color'>{el}</IonLabel>
                                <IonRadio slot="start" style={{ color: 'green' }} value={el} disabled={user.disableFlag} />
                              </IonItem>))}
                          </IonRadioGroup>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {((user.answerType == 'radio' && user.preFill == 'No' && user.staticQuestionReference != null) || (user.answerType == 'radio' && user.preFill == 'Yes' && user.answer == null && user.staticQuestionReference != null) || (user.answerType == 'radio' && user.preFill == 'Yes' && user.answer != null && user.staticQuestionReference != null)) ?
                    <IonRow>
                      <IonCol>
                        {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN')) ?
                          <IonLabel color="danger">
                            <b>{user.mandatoryText}</b>
                          </IonLabel>
                          : null}
                        <IonItem disabled={user.disableFlag}>
                          <IonRadioGroup className="app-font" value={user.answer} style={{ display: "flex" }} onIonChange={e => { this.radioOnchange(e, index) }}>
                            <IonLabel className="app-font"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style={{ color: 'red', fontWeight: 'bold' }}>*</sup> : null}</b></IonLabel>
                            {user.answerValue.split(',').map((el: string, k: number) => (
                              <IonItem key={k} className="ion-item-top-adjust">
                                <IonLabel className='color'>{el}</IonLabel>
                                <IonRadio slot="start" className='color' value={el} disabled={user.disableFlag} />
                              </IonItem>))}
                          </IonRadioGroup>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {/* {(user.answerType == 'radio' && user.answer != null && user.staticQuestionReference != null) ?
                    <IonRow>
                      <IonCol>
                        <IonItem disabled={user.disableFlag}>
                          <IonLabel className="color">{user.questionNumber} {user.mobileView} <IonLabel style = {{color : "#006884", textAlign : "end"}}>{user.answer}</IonLabel></IonLabel>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null} */}

                  {(user.answerType === 'Note' && user.hideElement) ?
                    <IonRow>
                      <IonCol>
                        <IonItem>
                          <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView}</b></IonLabel>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}


                  {((user.answerType === 'drop down hide' && user.hideElement && user.staticQuestionReference == null) || (user.answerType == 'drop down' && user.preFill == 'No' && user.staticQuestionReference == null) || (user.answerType == 'drop down' && user.preFill == 'Yes' && user.answer == null && user.staticQuestionReference == null) || (user.answerType === 'drop down' && user.preFill == 'Yes' && user.answer != null && user.questionReference != 'drain_field_location' && user.staticQuestionReference == null)) ?
                    <IonRow>
                      <IonCol>
                      {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN')) ?
                          <IonLabel color="danger">
                            <b>{user.mandatoryText}</b>
                          </IonLabel>
                        : null}
                        <IonItem>
                          <IonLabel className="app-font"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null}</b></IonLabel>
                          <IonSelect style={{ width: '500px !important', color: "#019849", fontWeight: "bold" }} disabled={user.disableFlag} value={user.answer} onIonChange={e => { this.dropdownOnchange(e, index) }}>
                            {user.answerValue.split(',').map((el: string, k: number) => (
                              <IonSelectOption value={el}>{el}</IonSelectOption>
                            ))}
                          </IonSelect>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {((user.answerType == 'drop down' && user.preFill == 'No' && user.staticQuestionReference != null) || (user.answerType == 'drop down' && user.preFill == 'Yes' && user.answer == null && user.staticQuestionReference != null) || (user.answerType === 'drop down' && user.preFill == 'Yes' && user.answer != null && user.staticQuestionReference != null)) ?
                    <IonRow>
                      <IonCol>
                      {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN')) ?
                          <IonLabel color="danger">
                            <b>{user.mandatoryText}</b>
                          </IonLabel>
                        : null}
                        <IonItem>
                          <IonLabel className="app-font"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null}</b></IonLabel>
                          <IonSelect style={{ width: '500px !important'}} className='color' disabled={user.disableFlag} value={user.answer} onIonChange={e => { this.dropdownOnchange(e, index) }}>
                            {user.answerValue.split(',').map((el: string, k: number) => (
                              <IonSelectOption className='color' value={el}>{el}</IonSelectOption>
                            ))}
                          </IonSelect>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                   {/* {(user.answerType === 'drop down' && user.preFill == 'Yes' && user.answer != null) ?
                    <IonRow>
                      <IonCol>
                        <IonItem disabled = {user.disableFlag}>
                          <IonLabel className="ion-text-wrap">{user.questionNumber} {user.mobileView} &nbsp; <IonBadge>{user.answer}</IonBadge></IonLabel>                        
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null} */}

                  {((user.answerType === 'multiselect' && user.hideElement) || (user.answerType == 'checkbox' && user.preFill == 'No') || (user.answerType == 'checkbox' && user.preFill == 'Yes' && user.answer == null)) ?
                    <IonRow>
                      <IonCol>
                      {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN')) ?
                          <IonLabel color="danger">
                            <b>{user.mandatoryText}</b>
                          </IonLabel>
                        : null}
                        <IonItem>
                          <IonLabel className="app-font"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null}</b> <IonBadge>{user.answer}</IonBadge></IonLabel>
                          <IonSelect multiple={true} style={{ width: '500px !important', color: "#019849", fontWeight: "bold" }} disabled={user.disableFlag} onIonChange={e => { this.dropdownMultiOnchange(e, index) }}>
                            {user.answerValue.split(',').map((el: string, k: number) => (
                              <IonSelectOption value={el}>{el}</IonSelectOption>
                            ))}
                          </IonSelect>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType == 'checkbox' && user.preFill == 'Yes' && user.answer != null) ?
                    <IonRow>
                      <IonCol>
                        <IonItem>
                          <IonLabel className="app-font"><b>{user.questionNumber} {user.mobileView}</b> &nbsp; <IonBadge>{user.answer}</IonBadge></IonLabel>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'Choose equipment') ?
                    <IonRow>
                      <IonCol>
                      {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN')) ?
                          <IonLabel color="danger">
                            <b>{user.mandatoryText}</b>
                          </IonLabel>
                        : null}
                        <IonItem>
                          <IonLabel className="app-font"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null}</b></IonLabel>
                          <IonSelect style={{ width: '500px !important', color: "#019849", fontWeight: "bold" }} disabled={user.disableFlag} value={user.answer} onIonChange={e => { this.OnChangeDropdown(e, this.selectedData.id, index, this.pageNumber) }}>
                            {user.answerValue.split(',').map((el: string, k: number) => (
                              <IonSelectOption value={el}>{el}</IonSelectOption>
                            ))}
                          </IonSelect>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType === 'range' || user.answerType === 'range inches' || user.answerType === 'range gallons') ?
                    <IonRow>
                      <IonCol>
                        {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN' || user.answer == 0)) ?
                          <IonLabel color="danger">
                            <b>{user.mandatoryText}</b>
                          </IonLabel>
                          : null}
                        <IonItem className="ion-range-adjust">
                          {(() => {
                            if (user.answerType == 'range' && !isNaN(user.answer)) {
                              return (
                                <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style={{ color: 'red', fontWeight: 'bold' }}>*</sup> : null} </b>&nbsp; <IonBadge>{this.state.data[index].answer}</IonBadge></IonLabel>
                              )
                            }
                            if (user.answerType == 'range' && isNaN(user.answer)) {
                              return (
                                <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style={{ color: 'red', fontWeight: 'bold' }}>*</sup> : null} </b>&nbsp; <IonBadge> 0 </IonBadge></IonLabel>
                              )
                            }
                          })()}

                          {(() => {
                            if (user.answerType == 'range inches' && !isNaN(user.answer && user.staticQuestionReference == null)) {
                              return (
                                <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style={{ color: 'red', fontWeight: 'bold' }}>*</sup> : null} </b>&nbsp; <IonBadge>{this.state.data[index].answer + "''"}</IonBadge></IonLabel>
                              )
                            }
                            if (user.answerType == 'range inches' && isNaN(user.answer && user.staticQuestionReference == null)) {
                              return (
                                <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style={{ color: 'red', fontWeight: 'bold' }}>*</sup> : null} </b>&nbsp; <IonBadge> 0'' </IonBadge></IonLabel>
                              )
                            }
                          })()}

                          {(() => {
                            if (user.answerType == 'range gallons' && !isNaN(user.answer)) {
                              return (
                                <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style={{ color: 'red', fontWeight: 'bold' }}>*</sup> : null} </b>&nbsp; <IonBadge>{this.state.data[index].answer + " gal"}</IonBadge></IonLabel>
                              )
                            }
                            if (user.answerType == 'range gallons' && isNaN(user.answer)) {
                              return (
                                <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style={{ color: 'red', fontWeight: 'bold' }}>*</sup> : null} </b>&nbsp; <IonBadge> 0 gal </IonBadge></IonLabel>
                              )
                            }
                          })()}
                          <IonRange pin={true} step={user.rangeStep} value={parseInt(user.answer)} disabled={user.disableFlag} min={user.answerValue[0]} max={user.answerValue[1]} color="secondary"
                            onIonChange={e => { this.rangeUpdate(e.detail.value, index) }}>
                            {(user.label) ? <IonBadge slot="start">{user.label[0]}</IonBadge> : null}
                            {(user.label) ? <IonBadge slot="end">{user.label[1]}</IonBadge> : null}
                          </IonRange>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {(user.answerType == 'range hide' && user.hideElement) ?
                     <IonRow>
                     <IonCol>
                     {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN' || user.answer == 0)) ?
                           <IonLabel color="danger">
                             <b>{user.mandatoryText}</b>
                           </IonLabel>
                         : null}
                    <IonItem className="ion-range-adjust">
                      <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null}</b> &nbsp;  <IonBadge>{this.state.data[index].answer}</IonBadge> &nbsp; <IonBadge>{this.state.data[index].answer * 25 + ' feet'}</IonBadge></IonLabel>
                      <IonRange pin={true} step={user.rangeStep} value={parseInt(user.answer)} disabled={user.disableFlag} min={user.answerValue[0]} max={user.answerValue[1]} color="secondary"
                        onIonChange={e => { this.rangeUpdate(e.detail.value, index) }}>
                        {(user.label) ? <IonBadge slot="start">{user.label[0]}</IonBadge> : null}
                        {(user.label) ? <IonBadge slot="end">{user.label[1]}</IonBadge> : null}
                      </IonRange>
                    </IonItem>
                    </IonCol>
                    </IonRow>
                    : null}

                  {((user.answerType == 'range hose' && user.preFill == 'Yes' && user.answer == null) || (user.answerType == 'range hose' && user.preFill == 'Yes' && user.answer == 0) || (user.answerType == 'range hose' && user.preFill == 'Yes' && user.answer != null && user.answer != 0)) ?
                     <IonRow>
                     <IonCol>
                     {(user.mandatory && this.disableNextPage && (!user.answer || user.answer == 'NaN' || user.answer == 0)) ?
                           <IonLabel color="danger">
                             <b>{user.mandatoryText}</b>
                           </IonLabel>
                         : null}
                    <IonItem className="ion-range-adjust">
                      <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView} {user.mandatory ? <sup style = {{color : 'red', fontWeight : 'bold'}}>*</sup> : null}</b> &nbsp;  <IonBadge>{this.state.data[index].answer}</IonBadge> &nbsp; <IonBadge>{this.state.data[index].answer * 25 + ' feet'}</IonBadge></IonLabel>
                      <IonRange pin={true} step={user.rangeStep} value={parseInt(user.answer)} disabled={user.disableFlag} min={user.answerValue[0]} max={user.answerValue[1]} color="secondary"
                        onIonChange={e => { this.rangeUpdate(e.detail.value, index) }}>
                        {(user.label) ? <IonBadge slot="start">{user.label[0]}</IonBadge> : null}
                        {(user.label) ? <IonBadge slot="end">{user.label[1]}</IonBadge> : null}
                      </IonRange>
                    </IonItem>
                    </IonCol>
                    </IonRow>
                    : null}
                </IonCardContent>
              )))}
              {/* {(() => {

                if (this.state.headerTO.title == 'PROPERTY INFO') {
                  return (
                    <IonRow>
                      <IonCol>
                        <IonButton
                          expand="block"
                          class="btncolor"
                          onClick={this.getEquipmentType}>
                          PUMPOUT QUESTIONS
                        </IonButton>
                      </IonCol>
                    </IonRow>
                  )
                }
              })()} */}

              {(() => {

                if (this.nextPageNumber != 0 && this.state.pumpoutDetailsTO.lastPage == false) {
                  return (
                    <IonRow>
                      <IonCol>
                        <IonButton
                          expand="block"
                          class="btncolor"
                          onClick={() => { this.gotoNextPage() }}>
                          PUMPOUT QUESTIONS
                        </IonButton>
                      </IonCol>
                    </IonRow>
                  )
                }
              })()}

              {(() => {

                if (this.state.headerTO.title == 'COMMENTS ON PROPERTY') {
                  return (
                    <IonRow>
                      <IonCol>
                        <IonButton
                          expand="block"
                          className="btncolor"
                          onClick={ () => this.getPumpOutReport(this.selectedData.id)} disabled = {this.state.disableSubmitButton}>
                          SUBMIT
                        </IonButton>
                      </IonCol>
                    </IonRow>
                  )
                }
              })()}

              {(() => {

                if (this.state.headerTO.title == 'PUMP OUT CANCELLATION' && this.currentPageNumber != 2) {
                  return (
                    <IonRow>
                      <IonCol>
                        <IonButton
                          expand="block"
                          class="btncolor"
                          onClick={() => this.getPumpOutReport(this.selectedData.id)} disabled = {this.state.disableSubmitButton}>
                          SUBMIT
                        </IonButton>
                      </IonCol>
                    </IonRow>
                  )
                }
              })()}
            </IonCard>
          </IonContent>
        </IonPage>
      </InsPage>
    );
  };

}

const InsPage = styled(IonPage)`
  ion-content{
  --ion-background-color:#cef2d0;
  
  }
  .ion-button{
  padding: 8px;
  background-color: #019849;
  color:#ffffff;
  border-radius: 4px;
  }
  ion-card-content{
  font-size: 14px !important;
  }
  ion-item{
  --ion-background-color:#fff;
  }
  .card_content{
  margin-top: 0;
  padding: 6px;
  bottom: 2px;
  color : #006884;
  background-color: #ffffff;
  font-size: 14px !important;
  }
  .btn_ins{
  padding: 8px;
  background-color: #019849;
  color: #fff;
  }
  .ion-item-top-adjust {
  position: relative;
  top: -10px;
  
  }
  .iontitle{
  color : #006884;
  }
  .alert-wrapper ion-overlay-wrapper sc-ion-alert-md{
  min-width: -webkit-fit-content;
  }
  .app-font {
    font-size : 15px;
    }
  .text-color {
    color : #019849;
    font-weight : bold;
  }
  .color {
    color : #006884;
    font-weight : bold;
  }
  
  `;

export default (PumpOutPage);